/* ============================================================
   VeizoHub Theme — global.js
   ============================================================ */
(function () {
  'use strict';

  const routes = (window.VeizoHub && window.VeizoHub.routes) || {};

  /* ---------- Utilities ---------- */
  function formatMoney(cents) {
    const format = (window.VeizoHub && window.VeizoHub.moneyFormat) || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/<[^>]*>/g, '');
  }

  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  let toastEl;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  const CART_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1.5"/><circle cx="19" cy="21" r="1.5"/><path d="M2 3h3l2.6 12.5a2 2 0 0 0 2 1.5h8.7a2 2 0 0 0 2-1.6L22 7H6"/></svg>';
  const CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4 12.5 5.5 5.5L20 6.5"/></svg>';
  const TRASH_SVG = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 15h10l1-15M10 11v6M14 11v6"/></svg>';
  const HEART_SVG = '<svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21S3 14.5 3 8.8A4.8 4.8 0 0 1 12 6a4.8 4.8 0 0 1 9 2.8C21 14.5 12 21 12 21z"/></svg>';

  function openCart() {
    if (document.getElementById('CartDrawer')) {
      toggleDrawer('CartDrawer', true);
    } else {
      window.location.href = routes.cart_url || '/cart';
    }
  }

  // "Added ✓" pop animation, then swap the button into a "View cart" state
  function celebrateAdd(btn) {
    if (!btn) return;
    btn.classList.remove('is-view-cart');
    btn.classList.add('is-added', 'atc-pop');
    btn.innerHTML = '<span class="atc-check">' + CHECK_SVG + '</span> Added!';
    clearTimeout(btn._atcTimer);
    btn._atcTimer = setTimeout(() => {
      btn.classList.remove('atc-pop', 'is-added');
      btn.classList.add('is-view-cart');
      btn.dataset.viewCart = '1';
      btn.innerHTML = CART_SVG + ' View cart';
    }, 1400);
  }

  function resetAddButton(btn, label) {
    if (!btn) return;
    clearTimeout(btn._atcTimer);
    delete btn.dataset.viewCart;
    btn.classList.remove('is-view-cart', 'is-added', 'atc-pop');
    if (label !== undefined) btn.textContent = label;
  }

  /* ---------- Overlay + drawers ---------- */
  const overlay = document.querySelector('[data-overlay]');
  let openDrawer = null;

  function showOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
  }
  function hideOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    setTimeout(() => { overlay.hidden = true; }, 250);
  }
  function toggleDrawer(id, open) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    const willOpen = open !== undefined ? open : !drawer.classList.contains('is-open');
    if (willOpen) {
      if (openDrawer && openDrawer !== drawer) openDrawer.classList.remove('is-open');
      drawer.classList.add('is-open');
      openDrawer = drawer;
      showOverlay();
      document.body.style.overflow = 'hidden';
      const focusable = drawer.querySelector('button, a, input');
      if (focusable) focusable.focus({ preventScroll: true });
    } else {
      drawer.classList.remove('is-open');
      if (openDrawer === drawer) openDrawer = null;
      hideOverlay();
      document.body.style.overflow = '';
    }
  }
  window.VeizoToggleDrawer = toggleDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      toggleDrawer(opener.getAttribute('data-drawer-open'), true);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      toggleDrawer(closer.closest('.drawer').id, false);
    }
  });
  if (overlay) overlay.addEventListener('click', () => { if (openDrawer) toggleDrawer(openDrawer.id, false); closeCategoriesMenu(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (openDrawer) toggleDrawer(openDrawer.id, false);
      closeCategoriesMenu();
      closePredictive();
    }
  });

  /* ---------- Categories dropdown ---------- */
  const catWrap = document.querySelector('.nav-categories');
  function closeCategoriesMenu() {
    if (catWrap) {
      catWrap.classList.remove('is-open');
      const menu = catWrap.querySelector('.nav-categories-menu');
      if (menu) menu.hidden = true;
    }
  }
  if (catWrap) {
    const btn = catWrap.querySelector('button');
    const menu = catWrap.querySelector('.nav-categories-menu');
    btn.addEventListener('click', () => {
      const isOpen = catWrap.classList.toggle('is-open');
      menu.hidden = !isOpen;
      btn.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', (e) => {
      if (!catWrap.contains(e.target)) closeCategoriesMenu();
    });
  }

  /* ---------- Cart ---------- */
  async function refreshCartSections() {
    try {
      const res = await fetch(`${routes.cart_url || '/cart'}?sections=cart-drawer`);
      const data = await res.json();
      if (data['cart-drawer']) {
        const holder = document.getElementById('CartDrawerSection');
        if (holder) {
          const dom = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          const fresh = dom.getElementById('CartDrawerSection');
          if (fresh) holder.innerHTML = fresh.innerHTML;
        }
      }
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (err) {
      /* network hiccup — leave current state */
    }
  }

  async function addToCart(body, button, opts) {
    opts = opts || {};
    let original;
    if (button) {
      original = button.innerHTML;
      button.disabled = true;
      button.innerHTML = '<span class="loading-spinner"></span>';
    }
    try {
      const res = await fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) {
        toast(data.description || data.message || 'Could not add to cart');
        return false;
      }
      await refreshCartSections();
      if (!opts.silent && (window.VeizoHub || {}).cartType === 'drawer' && document.getElementById('CartDrawer')) {
        toggleDrawer('CartDrawer', true);
      } else {
        toast('Added to cart ✓');
      }
      return true;
    } catch (err) {
      toast('Could not add to cart');
      return false;
    } finally {
      if (button) {
        button.disabled = false;
        button.innerHTML = original;
      }
    }
  }

  // Quick add buttons (product cards, wishlist drawer)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.viewCart) { openCart(); return; }
    const ok = await addToCart({ id: Number(btn.getAttribute('data-quick-add')), quantity: 1 }, btn);
    if (ok) celebrateAdd(btn);
  });

  // Product form AJAX submit
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[name="add"]');
    if (btn && btn.dataset.viewCart) { openCart(); return; }
    const formData = new FormData(form);
    const ok = await addToCart({
      id: Number(formData.get('id')),
      quantity: Number(formData.get('quantity') || 1)
    }, btn);
    if (ok) celebrateAdd(btn);
  });

  // Cart line changes (page + drawer)
  async function changeLine(line, quantity) {
    try {
      const res = await fetch(routes.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      });
      if (!res.ok) {
        const data = await res.json();
        toast(data.description || 'Could not update cart');
        return;
      }
      if (document.querySelector('[data-cart-page]')) {
        window.location.reload();
      } else {
        await refreshCartSections();
      }
    } catch (err) {
      toast('Could not update cart');
    }
  }

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-cart-remove'), 0);
      return;
    }
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('.qty-input');
      const input = wrap.querySelector('input');
      const step = qtyBtn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
      const min = Number(input.min || 1);
      const next = Math.max(min, Number(input.value || 1) + step);
      if (next !== Number(input.value)) {
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) changeLine(input.getAttribute('data-line-qty'), input.value);
  });

  // Cart note autosave
  document.addEventListener('change', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(routes.cart_update_url || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  });

  /* ---------- Predictive search ---------- */
  const searchForms = document.querySelectorAll('[data-predictive-search]');
  let activeResults = null;

  function closePredictive() {
    if (activeResults) { activeResults.hidden = true; activeResults = null; }
  }
  document.addEventListener('click', (e) => {
    if (activeResults && !e.target.closest('.header-search')) closePredictive();
  });

  searchForms.forEach((wrap) => {
    const input = wrap.querySelector('input[type="search"]');
    const results = wrap.querySelector('.predictive-results');
    if (!input || !results) return;

    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.hidden = true; return; }
      try {
        const url = `${routes.predictive_search_url || '/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const res = await fetch(url);
        const data = await res.json();
        const products = (((data.resources || {}).results || {}).products) || [];
        if (!products.length) { results.hidden = true; return; }
        results.innerHTML = `
          <ul>
            ${products.map((p) => `
              <li>
                <a href="${p.url}">
                  ${p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=84" alt="" loading="lazy">` : ''}
                  <span>
                    <span class="pr-title">${p.title}</span>
                    <span class="pr-price">${p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : ''}</span>
                  </span>
                </a>
              </li>`).join('')}
          </ul>
          <a class="pr-all" href="/search?q=${encodeURIComponent(q)}">See all results for “${q.replace(/</g, '&lt;')}”</a>`;
        results.hidden = false;
        activeResults = results;
      } catch (err) {
        results.hidden = true;
      }
    }, 250);

    input.addEventListener('input', run);
    input.addEventListener('focus', () => { if (results.innerHTML.trim()) results.hidden = false; });
  });

  /* ---------- Countdown timers ---------- */
  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    const units = {
      d: el.querySelector('[data-cd-days]'),
      h: el.querySelector('[data-cd-hours]'),
      m: el.querySelector('[data-cd-mins]'),
      s: el.querySelector('[data-cd-secs]')
    };
    function tick() {
      let diff = Math.max(0, end - Date.now());
      const d = Math.floor(diff / 86400000); diff -= d * 86400000;
      const h = Math.floor(diff / 3600000); diff -= h * 3600000;
      const m = Math.floor(diff / 60000); diff -= m * 60000;
      const s = Math.floor(diff / 1000);
      if (units.d) units.d.textContent = String(d).padStart(2, '0');
      if (units.h) units.h.textContent = String(h).padStart(2, '0');
      if (units.m) units.m.textContent = String(m).padStart(2, '0');
      if (units.s) units.s.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach((show) => {
    const track = show.querySelector('.hero-track');
    const slides = show.querySelectorAll('.hero-slide');
    const dots = show.querySelectorAll('.hero-dots button');
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const autoplay = show.getAttribute('data-autoplay') !== 'false';
    const interval = Number(show.getAttribute('data-interval') || 5) * 1000;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
    }
    function schedule() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), interval);
    }
    dots.forEach((d, di) => d.addEventListener('click', () => { go(di); schedule(); }));
    const prev = show.querySelector('.hero-arrow--prev');
    const next = show.querySelector('.hero-arrow--next');
    if (prev) prev.addEventListener('click', () => { go(index - 1); schedule(); });
    if (next) next.addEventListener('click', () => { go(index + 1); schedule(); });
    show.addEventListener('mouseenter', () => clearInterval(timer));
    show.addEventListener('mouseleave', schedule);
    schedule();
  });

  /* ---------- Product page: variants + gallery ---------- */
  const productForm = document.querySelector('[data-product-wrapper]');
  if (productForm) {
    const jsonTag = productForm.querySelector('[data-product-json]');
    const product = jsonTag ? JSON.parse(jsonTag.textContent) : null;
    const idInput = productForm.querySelector('input[name="id"]');
    const priceEl = productForm.querySelector('[data-product-price]');
    const compareEl = productForm.querySelector('[data-product-compare]');
    const offEl = productForm.querySelector('[data-product-off]');
    const addBtn = productForm.querySelector('[name="add"]');
    const buyBtn = productForm.querySelector('[data-buy-now]');

    function currentOptions() {
      return Array.from(productForm.querySelectorAll('[data-option-index]')).map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function onVariantChange() {
      if (!product) return;
      const opts = currentOptions();
      const variant = product.variants.find((v) =>
        v.options.every((o, i) => o === opts[i])
      );
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; resetAddButton(addBtn, 'Unavailable'); }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (offEl) {
        offEl.hidden = !onSale;
        if (onSale) offEl.textContent = '-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        resetAddButton(addBtn, variant.available ? 'Add to cart' : 'Sold out');
      }
      if (buyBtn) buyBtn.disabled = !variant.available;
      if (variant.featured_image) {
        activateGalleryMedia(variant.featured_image.id);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    productForm.querySelectorAll('[data-option-index] input').forEach((input) => {
      input.addEventListener('change', onVariantChange);
    });

    if (buyBtn) {
      buyBtn.addEventListener('click', () => {
        const qty = productForm.querySelector('input[name="quantity"]');
        window.location.href = `/cart/${idInput.value}:${(qty && qty.value) || 1}`;
      });
    }

    function activateGalleryMedia(id) {
      const media = productForm.querySelector(`[data-gallery-media="${id}"]`);
      if (!media) return;
      productForm.querySelectorAll('[data-gallery-media]').forEach((item) => {
        const isActive = item === media;
        item.classList.toggle('is-active', isActive);
        if (!isActive) item.querySelectorAll('video').forEach((video) => video.pause());
      });
      productForm.querySelectorAll('[data-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === String(id));
      });
    }

    // Gallery thumbnails
    document.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      activateGalleryMedia(thumb.getAttribute('data-media-id'));
    });

    // Gallery prev / next arrows
    function stepGallery(dir) {
      const thumbs = Array.from(productForm.querySelectorAll('.product-thumbs [data-thumb]'));
      if (!thumbs.length) return;
      let i = thumbs.findIndex((t) => t.classList.contains('is-active'));
      if (i < 0) i = 0;
      const next = thumbs[(i + dir + thumbs.length) % thumbs.length];
      next.click();
      next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    const galleryPrev = document.querySelector('[data-gallery-prev]');
    const galleryNext = document.querySelector('[data-gallery-next]');
    if (galleryPrev) galleryPrev.addEventListener('click', () => stepGallery(-1));
    if (galleryNext) galleryNext.addEventListener('click', () => stepGallery(1));
  }

  /* ---------- Collection: facets + sorting ---------- */
  const facetsForm = document.querySelector('[data-facets-form]');
  if (facetsForm) {
    facetsForm.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"]')) facetsForm.submit();
    });
  }
  const sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  const facetsToggle = document.querySelector('[data-facets-toggle]');
  if (facetsToggle) {
    facetsToggle.addEventListener('click', () => {
      document.querySelector('.facets-wrap').classList.toggle('is-open');
    });
  }

  /* ---------- Wishlist ---------- */
  const WISHLIST_KEY = 'veizohub:wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (err) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (err) { /* storage full / private mode */ }
    renderWishlist();
  }

  function renderWishlist() {
    const list = getWishlist();

    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    const drawerCount = document.querySelector('[data-wishlist-drawer-count]');
    if (drawerCount) drawerCount.textContent = list.length;

    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      try {
        const p = JSON.parse(btn.getAttribute('data-product'));
        btn.classList.toggle('is-active', list.some((i) => String(i.id) === String(p.id)));
      } catch (err) { /* malformed data attribute */ }
    });

    const holder = document.querySelector('[data-wishlist-items]');
    if (!holder) return;
    if (!list.length) {
      holder.innerHTML = `
        <div class="cart-empty">
          ${HEART_SVG}
          <h3>Your wishlist is empty</h3>
          <p style="color: var(--color-text-muted)">Tap the ♥ on any product to save it here.</p>
          <button type="button" class="btn" data-drawer-close>Keep browsing</button>
        </div>`;
      return;
    }
    holder.innerHTML = list.map((item) => `
      <div class="wishlist-item">
        <a href="${escapeHtml(item.url)}" class="wishlist-item-img">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="70" height="70">` : ''}
        </a>
        <div>
          <a href="${escapeHtml(item.url)}" class="cart-item-title">${escapeHtml(item.title)}</a>
          <p class="wishlist-item-price">${item.price || ''}</p>
          <div class="wishlist-item-actions">
            ${item.available === false
              ? '<span class="wishlist-soldout">Sold out</span>'
              : item.hasOptions
                ? `<a class="btn btn--sm" href="${escapeHtml(item.url)}">Choose options</a>`
                : `<button type="button" class="btn btn--sm" data-quick-add="${Number(item.variantId) || 0}">${CART_SVG} Add to cart</button>`}
            <button type="button" class="wishlist-remove" data-wishlist-remove="${escapeHtml(String(item.id))}" aria-label="Remove ${escapeHtml(item.title)} from wishlist">${TRASH_SVG}</button>
          </div>
        </div>
      </div>`).join('');
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      e.preventDefault();
      let p;
      try { p = JSON.parse(toggle.getAttribute('data-product')); } catch (err) { return; }
      const list = getWishlist();
      const idx = list.findIndex((i) => String(i.id) === String(p.id));
      if (idx > -1) {
        list.splice(idx, 1);
        toast('Removed from wishlist');
      } else {
        list.push(p);
        toast('Added to wishlist ♥');
        toggle.classList.add('wish-pop');
        setTimeout(() => toggle.classList.remove('wish-pop'), 500);
      }
      saveWishlist(list);
      return;
    }
    const remove = e.target.closest('[data-wishlist-remove]');
    if (remove) {
      e.preventDefault();
      const id = remove.getAttribute('data-wishlist-remove');
      saveWishlist(getWishlist().filter((i) => String(i.id) !== id));
    }
  });

  renderWishlist();

  /* ---------- Quick view ---------- */
  const qvModal = document.getElementById('QuickView');

  function openQuickView() {
    if (!qvModal) return;
    qvModal.hidden = false;
    requestAnimationFrame(() => qvModal.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  }
  function closeQuickView() {
    if (!qvModal || qvModal.hidden) return;
    qvModal.classList.remove('is-open');
    setTimeout(() => { qvModal.hidden = true; }, 200);
    document.body.style.overflow = '';
  }

  function qvImageUrl(src, width) {
    if (!src) return '';
    return src + (src.includes('?') ? '&' : '?') + 'width=' + width;
  }

  function renderQuickView(content, product) {
    const images = product.images || [];
    const hasOptions = !(product.variants.length === 1 && product.variants[0].title === 'Default Title');
    const initial = product.variants.find((v) => v.available) || product.variants[0];
    let imgIndex = 0;

    const optionsHtml = hasOptions
      ? product.options.map((name, oi) => {
          const values = [];
          product.variants.forEach((v) => { if (!values.includes(v.options[oi])) values.push(v.options[oi]); });
          return `
            <div class="qv-option">
              <label for="QvOption-${oi}">${escapeHtml(name)}</label>
              <select id="QvOption-${oi}" data-qv-option="${oi}">
                ${values.map((val) => `<option value="${escapeHtml(val)}" ${initial.options[oi] === val ? 'selected' : ''}>${escapeHtml(val)}</option>`).join('')}
              </select>
            </div>`;
        }).join('')
      : '';

    content.innerHTML = `
      <div class="qv-media">
        ${images.length
          ? `<img data-qv-img src="${escapeHtml(qvImageUrl(images[0], 600))}" alt="${escapeHtml(product.title)}" width="600" height="600">`
          : '<span class="media-placeholder"></span>'}
        ${images.length > 1 ? `
          <button type="button" class="gallery-arrow gallery-arrow--prev" data-qv-prev aria-label="Previous image"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 6-6 6 6 6"/></svg></button>
          <button type="button" class="gallery-arrow gallery-arrow--next" data-qv-next aria-label="Next image"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></button>` : ''}
      </div>
      <div class="qv-info">
        <h3>${escapeHtml(product.title)}</h3>
        <div class="qv-price" data-qv-price></div>
        ${optionsHtml}
        <div class="qv-buy">
          <div class="qty-input">
            <button type="button" data-qty-change="down" aria-label="Decrease quantity">&minus;</button>
            <input type="number" value="1" min="1" data-qv-qty aria-label="Quantity">
            <button type="button" data-qty-change="up" aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="btn" data-qv-add></button>
        </div>
        <a class="qv-details-link" href="${escapeHtml(product.url)}">View full details ›</a>
      </div>`;

    const priceEl = content.querySelector('[data-qv-price]');
    const addBtn = content.querySelector('[data-qv-add]');
    const mainImg = content.querySelector('[data-qv-img]');
    let currentVariant = initial;

    function applyVariant() {
      if (!currentVariant) {
        priceEl.innerHTML = '';
        addBtn.disabled = true;
        resetAddButton(addBtn, 'Unavailable');
        return;
      }
      const onSale = currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price;
      priceEl.innerHTML = `
        <span class="now ${onSale ? 'sale' : ''}">${formatMoney(currentVariant.price)}</span>
        ${onSale ? `<span class="was">${formatMoney(currentVariant.compare_at_price)}</span>` : ''}`;
      addBtn.disabled = !currentVariant.available;
      resetAddButton(addBtn, currentVariant.available ? 'Add to cart' : 'Sold out');
      if (mainImg && currentVariant.featured_image && currentVariant.featured_image.src) {
        const vi = images.indexOf(currentVariant.featured_image.src);
        if (vi > -1) imgIndex = vi;
        mainImg.src = qvImageUrl(currentVariant.featured_image.src, 600);
      }
    }
    applyVariant();

    content.querySelectorAll('[data-qv-option]').forEach((select) => {
      select.addEventListener('change', () => {
        const opts = Array.from(content.querySelectorAll('[data-qv-option]')).map((s) => s.value);
        currentVariant = product.variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
        applyVariant();
      });
    });

    function stepQvImage(dir) {
      if (!mainImg || images.length < 2) return;
      imgIndex = (imgIndex + dir + images.length) % images.length;
      mainImg.src = qvImageUrl(images[imgIndex], 600);
    }
    const qvPrev = content.querySelector('[data-qv-prev]');
    const qvNext = content.querySelector('[data-qv-next]');
    if (qvPrev) qvPrev.addEventListener('click', () => stepQvImage(-1));
    if (qvNext) qvNext.addEventListener('click', () => stepQvImage(1));

    addBtn.addEventListener('click', async () => {
      if (addBtn.dataset.viewCart) { closeQuickView(); openCart(); return; }
      if (!currentVariant) return;
      const qty = content.querySelector('[data-qv-qty]');
      const ok = await addToCart({ id: currentVariant.id, quantity: Number((qty && qty.value) || 1) }, addBtn, { silent: true });
      if (ok) celebrateAdd(addBtn);
    });
  }

  document.addEventListener('click', async (e) => {
    const qvBtn = e.target.closest('[data-quick-view]');
    if (qvBtn) {
      e.preventDefault();
      const handle = qvBtn.getAttribute('data-quick-view');
      if (!qvModal) { window.location.href = '/products/' + handle; return; }
      const content = qvModal.querySelector('[data-qv-content]');
      content.innerHTML = '<div class="qv-loading"><span class="loading-spinner"></span></div>';
      openQuickView();
      try {
        const res = await fetch('/products/' + handle + '.js');
        if (!res.ok) throw new Error('not found');
        renderQuickView(content, await res.json());
      } catch (err) {
        window.location.href = '/products/' + handle;
      }
      return;
    }
    if (e.target.closest('[data-qv-close]')) {
      e.preventDefault();
      closeQuickView();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeQuickView();
  });

  /* ---------- Rotating search placeholder ---------- */
  const phInput = document.querySelector('.header-search input[type="search"]');
  const phTag = document.querySelector('[data-search-suggestions]');
  if (phInput && phTag) {
    let titles = [];
    try { titles = (JSON.parse(phTag.textContent) || []).filter(Boolean); } catch (err) { /* no suggestions */ }
    if (titles.length) {
      let idx = Math.floor(Math.random() * titles.length);

      function rotatePlaceholder() {
        const title = titles[idx % titles.length];
        idx++;
        phInput.classList.add('ph-fade');
        setTimeout(() => {
          phInput.setAttribute('placeholder', 'Search "' + title + '"');
          phInput.dataset.suggestion = title;
          phInput.classList.remove('ph-fade');
        }, 250);
      }

      rotatePlaceholder();
      setInterval(() => {
        if (phInput.value.trim()) return;
        rotatePlaceholder();
      }, 3500);

      const phForm = phInput.closest('form');
      if (phForm) {
        phForm.addEventListener('submit', (e) => {
          if (!phInput.value.trim()) {
            if (phInput.dataset.suggestion) {
              phInput.value = phInput.dataset.suggestion;
            } else {
              e.preventDefault();
            }
          }
        });
      }
    }
  }
})();
